<!-- 增改字段 -->
<template>
  <div>
    <el-dialog
      :title="`选择字段${selfDetail.name}(已选${selfDetail.list.length})`"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <vxe-grid size="mini" border :height="256" :data="noChooseList" :columns="showColumn">
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link
              size="mini"
              type="success"
              icon="vxe-icon-add"
              title="添加"
              @click="itemAdd(row)"
            >
              添加
            </el-link>
          </template>
        </vxe-grid>
        <vxe-grid
          class="m-t-10"
          size="mini"
          :height="256"
          :data="selfDetail.list"
          :columns="activeColumn"
        >
          <!-- slot_default -->
          <template #default_operate="{ row, rowIndex }">
            <el-link
              size="mini"
              :type="row.is_show ? 'success' : 'info'"
              :icon="row.is_show ? 'vxe-icon-eye-fill' : 'vxe-icon-eye-fill-close'"
              :title="row.is_show ? '已显示' : '已隐藏'"
              :disabled="!row.zi_duan_ku_id"
              @click="itemToggle(rowIndex)"
            >
              {{ row.is_show ? '已显示' : '已隐藏' }}
            </el-link>
            <el-link
              v-if="row.is_edit"
              size="mini"
              type="danger"
              icon="vxe-icon-delete"
              title="删除"
              @click="itemDelete(rowIndex)"
            >
              删除
            </el-link>
          </template>
        </vxe-grid>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    index: {
      type: [Number],
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {},
      allList: [],
      headerFilterUrl: '/admin/gcvip/ziDuanKu/searchHeard',
      filterData: {},
      showColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          field: 'name',
          title: '字段名称',
          width: 300,
          slots: { header: 'header_input' }
        },
        { field: 'lei_xing_str', title: '字段类型', width: 200 },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'name', title: '字段名称', width: 300 },
        { field: 'lei_xing_str', title: '字段类型', width: 200 },
        { title: '操作', slots: { default: 'default_operate' } }
      ]
    }
  },
  computed: {
    // 未选择数据列表
    noChooseList() {
      let result = []
      this.allList.forEach((itemSt) => {
        let isNotRepect = this.selfDetail.list.every((itemNd) => {
          return itemSt.id !== itemNd.zi_duan_ku_id
        })
        if (isNotRepect) result.push(this.$util.deepCopy(itemSt))
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfDetail = this.$util.deepCopy(this.list[this.index])
    this.getZiDuanAllList()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.getZiDuanAllList()
    },
    // 获取所有字段
    getZiDuanAllList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/ziDuanKu/search',
        data: {
          filterData: this.filterData,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.allList = res.data.list
        }
      })
    },
    // 项-添加
    itemAdd(row) {
      let result = {
        ...row,
        id: '',
        zi_duan_ku_id: row.id,
        is_show: true,
        is_edit: true,
        is_Set: false,
        set_symbol: '',
        set_options: [],
        set_gong_shi: []
      }

      // 输入框(分隔)、下拉框、公式
      let isSet = row.lei_xing_id === 4 || row.lei_xing_id === 8 || row.lei_xing_id === 11
      if (isSet) result.is_set = true

      this.selfDetail.list.push(result)
    },
    // 项-删除
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    // 项-切换
    itemToggle(index) {
      this.selfDetail.list[index].is_show = !this.selfDetail.list[index].is_show
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.selfDetail.list.forEach((item) => {
        if (item.is_edit) {
          // if (item.lei_xing_id === 4) item.set_symbol = ''
          // if (item.lei_xing_id === 8) item.set_options = []
          // if (item.lei_xing_id === 11) item.set_gong_shi = []
        }
      })
      this.$emit('success', this.selfDetail.list)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-link {
    vertical-align: inherit;
  }
}
</style>
